var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: 12 } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "7" } },
                    [
                      _c(
                        "v-toolbar",
                        { staticClass: "d-inline-block", attrs: { flat: "" } },
                        [
                          _c("v-toolbar-title", { staticClass: "mr-3" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.selectedCompanyName) +
                                " Databases "
                            ),
                          ]),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "float-left mr-5 elevation-0 primary--text",
                                              attrs: {
                                                fab: "",
                                                text: "",
                                                "x-small": "",
                                                color: "default",
                                                loading: !_vm.dbsLoaded,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.refreshLightningDbs()
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "24",
                                                color: "primary",
                                              },
                                            },
                                            [_vm._v("refresh")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [_c("span", [_vm._v("Refresh Databases")])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "pt-4 pb-0", attrs: { cols: "4" } },
                    [
                      _c("v-select", {
                        staticClass: "float-right",
                        attrs: {
                          items: _vm.lightningCompanies,
                          "item-text": "name",
                          "item-value": "id",
                          label: "Company",
                        },
                        on: { change: _vm.changeCompany },
                        model: {
                          value: _vm.selectedCompanyId,
                          callback: function ($$v) {
                            _vm.selectedCompanyId = $$v
                          },
                          expression: "selectedCompanyId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "1" } }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: 12 } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items: _vm.databases,
                  "single-select": true,
                  options: _vm.tableOptions,
                  "footer-props": {
                    "items-per-page-options": [
                      15,
                      30,
                      50,
                      { text: "All", value: -1 },
                    ],
                  },
                  loading: !_vm.dbsLoaded,
                  "calculate-widths": true,
                  "no-data-text": "No databases found",
                },
                on: {
                  "click:row": _vm.rowClick,
                  "update:options": function ($event) {
                    _vm.tableOptions = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.id`,
                      fn: function ({}) {
                        return [
                          _c("div", { staticClass: "text-center w-40" }, [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/lightning-database.svg"),
                              },
                            }),
                          ]),
                        ]
                      },
                    },
                    {
                      key: `item.displayName`,
                      fn: function ({ item }) {
                        return [
                          _c("span", { staticClass: "mr-3" }, [
                            _vm._v(" " + _vm._s(item.displayName) + " "),
                          ]),
                          item === _vm.selectedDb[0]
                            ? _c(
                                "v-menu",
                                {
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "ml-1 mr-4",
                                                    attrs: {
                                                      height: "16",
                                                      width: "16",
                                                      icon: "",
                                                      color: "primary",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("more_horiz"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          attrs: { dense: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showDeleteDbWarning = true
                                            },
                                          },
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(" Delete Database "),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: `item.uploadedDT`,
                      fn: function ({ item }) {
                        return [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.displayUploadedDT(item.uploadedDT))
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedDb,
                  callback: function ($$v) {
                    _vm.selectedDb = $$v
                  },
                  expression: "selectedDb",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showDeleteDbWarning
        ? _c(
            "v-dialog",
            {
              attrs: {
                width: "500px",
                "overlay-color": "transparent",
                "content-class": "bordered",
              },
              model: {
                value: _vm.showDeleteDbWarning,
                callback: function ($$v) {
                  _vm.showDeleteDbWarning = $$v
                },
                expression: "showDeleteDbWarning",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [_vm._v(" Delete Lightning DB ")]),
                  _c("v-card-text", [
                    _vm._v(
                      " Are you sure you want to delete database " +
                        _vm._s(_vm.selectedDb[0].displayName) +
                        " ? "
                    ),
                  ]),
                  _c(
                    "v-card-actions",
                    { staticClass: "text-right" },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              _vm.showDeleteDbWarning = false
                            },
                          },
                        },
                        [_vm._v("KEEP")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "error" },
                          on: {
                            click: function ($event) {
                              return _vm.deleteDb()
                            },
                          },
                        },
                        [_vm._v("DELETE")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }